import { render, staticRenderFns } from "./ViewChat.vue?vue&type=template&id=5e4708c2&"
import script from "./ViewChat.vue?vue&type=script&lang=ts&"
export * from "./ViewChat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports